import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import Appointments from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/appointments'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'appointments_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'appointments_list',
          meta: {
            featureFlag: FEATURE_FLAGS.APPOINTMENTS,
            permissions: [...ROLES],
          },
          component: Appointments,
        },
      ],
    },
  ],
};
